import axiosInstance from '@/utils/api.js'

var state = {
  general: []
}

var getters = {
  GENERAL: (state) => {
    return state.general
  }
}

var mutations = {
  SET_GENERAL: (state, payload) => {
    state.general = payload
  }
}

var actions = {
  GET_GENERAL: async (context, payload) => {
    let result = await axiosInstance.get('/reports/general?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&account_id=0&accounting_period_id=0' + '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_GENERAL', result.data)
    }
  },
  CLEAR_GENERAL: (context) => {
    context.commit('SET_GENERAL', [])
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/general.js